<template>
  <d-container fluid class="order main-content-container align-items-center justify-content-center">
    <d-col cols="12">
      <d-row class="justify-content-center">

        <div class="page-header row no-gutters py-4 col-lg-10 px-0">
          <div class="d-flex justify-content-between col-12">
            <div class="text-left text-sm-left mb-0">
              <span class="text-uppercase page-subtitle">{{ $t('order.index.title') }}</span>
              <h3 class="page-title">Overview</h3>
            </div>
          </div>
        </div>

        <d-card class="col-lg-10 card px-0">
          <d-card-body>
            <order-table @onRowClick="redirectTo" class="table-hover table-click table-md" :loading="$apollo.queries.getOrders.loading" :rows="d_orders">
              <template #header_status>
                <th v-text="$t('order.status.title')" />
              </template>
            </order-table>
          </d-card-body>
        </d-card>
      </d-row>
    </d-col>
  </d-container>
</template>

<script>
import * as moment from 'moment';
import { mapMutations } from 'vuex';
import OrderTable from '@/components/order/Table';

export default {
  name: 'order-index',
  components: { OrderTable },
  data () {
    return {
      d_orders: [],
    };
  },
  methods: {
    ...mapMutations('oneTimeUser', ['setHasAccount']),

    redirectTo ({ row }) {
      this.$router.push({
        name: 'order.detail',
        params: {
          id: row.id,
        }
      });
    },
    checkForAccount () {
      if (this.$oidc.userProfile.sub.indexOf('order-') === -1 || !this.d_orders.length) {
        return;
      }

      const firstOrder = this.d_orders[0];

      this.setHasAccount(firstOrder.userID !== "");
    },
  },
  apollo: {
    getOrders: function () {
      return {
        variables: {
          email: this.$oidc.userProfile.email,
          status: "COMPLETED",
        },
        update: function (data) {
          // Sort the orders by start date. Order with the earliest start date comes first.
          this.d_orders = data.orders.sort((a,b) => {
            return moment(a.from).diff(b.from);
          });


         // this.checkForAccount();
        },
        query: require('@/graphql/bookings/GetBookings.gql'),
      };
    },
  },
};
</script>
